import * as z from "zod";
import { userFacingError } from "../authorization";
import { mutator } from "./mutator";

export const cancelPushLiveRequest = mutator({
  schema: z.object({ requestId: z.string() }),
  description: "Withdraws your own push request for a branch.",
  interactionType: "delete",
  resolve: {
    request: { kind: "pushLiveRequest", from: "requestId" },
  },
  permissions: {
    none: "the requester withdraws their own request; ownership is checked in fn",
  },
  fn: async ({ tx, ctx, args: { request } }) => {
    if (request.requestedByUserId !== ctx.userId)
      throw userFacingError("Push request not found");
    await tx.mutate.pushLiveRequests.delete({ id: request.id });
  },
});
